import * as React from 'react';
type SvgArrowProps = {
  externalClass?: string,
  title?: string
};
const SvgArrow: React.SFC<SvgArrowProps> = ({externalClass, title = ''}) => {
  return (
    <svg
      role="button"
      version="1.1"
      viewBox="-304 6.5 7 14"
      x="0"
      y="0"
      xmlSpace="preserve"
      className={externalClass}
      aria-labelledby="navigate-to-prev-page-arrow"
    >
      <title id="navigate-to-prev-page-arrow">{title}</title>
      <polygon points="-303.3 20.5 -304 19.9 -298.3 13.5 -304 7.2 -303.3 6.5 -297 13.5" />
    </svg>
  );
};
export default SvgArrow;
